<template>
  <div>
    <footer>
      <div class="footer-links">
        <div v-if="currentContent()">
            <div class="body">Loading...</div>
          </div>
        <div v-else class="sectionOne">
          <h3>Girlguiding</h3>
          <ul>
            <li v-for="(route, index) in sectionOne" :key="index">
            <a v-if="route.external" :href="route.path" target="_blank">{{route.label}}</a>
            <router-link v-else :to="route.path">{{route.label}}</router-link>
            </li>
          </ul>
          </div>
          <div class="sectionTwo">
          <h3>Stone Outward</h3>
          <ul>
            <li v-for="(route, index) in sectionTwo" :key="index">
            <a v-if="route.external" :href="route.path" target="_blank">{{route.label}}</a>
            <router-link v-else :to="route.path">{{route.label}}</router-link>
            </li>
          </ul>
       </div>
        <div class="sectionThree">
          <h3>Other</h3>
          <ul>
            <li v-for="(route, index) in sectionThree" :key="index">
            <a v-if="route.external" :href="route.path" target="_blank">{{route.label}}</a>
            <router-link v-else :to="route.path">{{route.label}}</router-link>
            </li>
          </ul>
        </div>

      </div>
      <hr/>
      
      <div class="container end-footer">
         <div>
          <!-- <small>Made by
            <a href="#" target="_blank">Louise Amelia</a>
          </small>-->
          <p> &copy; {{year}}, Girlguiding, Charity Number 306016</p>
        </div> 
        <ul>
          <li>
            <a href="https://www.facebook.com/GirlGuidingStoneOutwardDivision">
              <img src="@/app/assets/img/social-media/white/facebook-white.png" alt="facebook">
            </a>
          </li>
          <li>
            <a href="#">
              <img src="@/app/assets/img/social-media/white/mail.png" alt="mail">
            </a>
          </li>
          <li>
            <a href="#">
              <img src="@/app/assets/img/social-media/white/Youtube.png" alt="youtube">
            </a>
          </li>
        </ul>
        </div>
        
        
    </footer>
  </div>
</template>

<script>
import { footerRoutesRef } from '@/admin/firebase_config'
export default {
  name: 'app-footer',
  firebase: {
    routes: footerRoutesRef
  },
  data () {
    return {
      subscriberEmail: '',
      isSubscribed: false,
      sectionOne:[],
      sectionTwo:[],
      sectionThree:[],
      year:2020
    }
  },
  created: function () {

  },
  methods: {
    displayYear (){
      this.year = new Date().getFullYear();
    },
    subscribeNewsLetter () {
      if (!this.subscriberEmail) {
        this.$refs['input-subscriber-email'].focus()
      } else {
        this.isSubscribed = true
      }
    },
    currentContent ()
    {
      if(this.sectionOne.length === 0|| this.sectionTwo.length === 0 || this.sectionThree.length === 0)
      {
      for(var i = 0; i < this.routes.length; i++)
      {
        if(this.routes[i].section === 'One')
        {
          this.sectionOne.push(this.routes[i])
        }
        else if(this.routes[i].section === 'Two')
        {
          this.sectionTwo.push(this.routes[i])
        }
        else
        {
          this.sectionThree.push(this.routes[i])
        }
      }
      
      // return false;
      
    }
    console.log(this.sectionOne);
    return false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/app/styles/index.scss';

footer hr{
  margin:0 20px;
}
/*---------------------
       Contact Section
  ---------------------*/
.footer-links{
  max-width:1400px;
  margin:auto;
  padding:20px;
  display:flex;
  display:-webkit-flex;
    flex-wrap:wrap;
    flex-direction:row;
    justify-content:space-around;
    div{
      margin:10px;
    }
    h3{
      font-size:25px;
      color:white;
      font-weight:600;
       padding: 0 20px;
    }
  ul{
    // display:flex;
    // flex-wrap:wrap;
    // flex-direction:row;

    li {
      display:flex;
      display:-webkit-flex;
      a{
        color:white;
        padding: 10px 20px;
        font-size:15px;
      }
    }
  }
}
.contact {
  background-color: $color-orange;
  color: #ffffff;
  .container {
    padding: 65px 0;
    flex-direction: row;
    > div {
      width: 50%;
      text-align: center;
      &.content {
        text-align: left;
        p {
          padding-bottom: 30px;
          text-align: left;
        }
        .alert-subscription {
          padding: 10px;
          color: $color-orange;
          font-weight: bold;
          background-color: $color-gray-light;
        }
      }
    }
    .is-heading {
      color: #ffffff;
    }
    form {
      max-width: 800px;
      width: 80%;
    }
    hr {
      color: #ffffff;
    }
  }
}

@media (max-width: 600px) {
  .contact form input {
    margin: 0;
  }
  .contact .container {
    display: block;
    padding: 30px !important;
    .icon-box {
      display: none;
    }
    > div {
      width: 100%;
      display: block;
      padding-bottom: 20px;
    }
    form {
      width: 100%;
      .form-icon-wrapper,
      input {
        width: 100%;
      }
    }
  }
}

/*-------------
       Footer
  -------------*/

footer {
  background-color: $color-darkgrey;
  border-top: 1px solid #ffffff;
  .container {
    display: flex;
    flex-direction: row;
    align-items: left;
    text-align: left;
    color: #fff;
    padding: 40px 0;
    justify-content: space-evenly;
    a {
      color: #ffffff;
    }
    ul {
      width: 50%;
      padding: 0 50px;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      li {
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
}

@media (max-width: 700px) {
  footer {
    padding: 80px 15px;
  }
}

@media (max-width: 600px) {
  .contact {
    .content p {
      margin-top: 15px;
    }

  }
  footer {
    padding: 0px;
    .container {
      display: block;
      ul {
        width: 100%;
        margin: 20px auto;
        text-align: center;
      }
    }
  }
}
.end-footer{

}
</style>
